import * as React from 'react';
import styled from '@emotion/styled';

const background = require('../../../media/big-logo-black.png');

export const BasicPageWidget: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <S.Container>
      <S.Backdrop></S.Backdrop>
      <S.Top>{props.children}</S.Top>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
  `;

  export const Top = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 40px;
  `;

  export const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-position: left 10% top -110px;
    background-size: 1000px;
    opacity: 0.1;
  `;
}
